import React from 'react'

import {Box, Flex, Text} from '../../../vanilla'

const SeparatorLine = () => (
  <Box
    as="hr"
    paddingX="10px"
    style={{
      color: '#E2E2E2',
      border: '0.1px solid #E2E2E2',
      width: '50px',
    }}
  />
)

const Separator = () => (
  <Flex align="center" justify="center" gap="10px">
    <SeparatorLine />
    <Text variant="text1" color="accent2">or</Text>
    <SeparatorLine />
  </Flex>
)

export default Separator
